import { defineComponent as _defineComponent } from 'vue'
import { Ref, computed, onBeforeMount, ref } from 'vue';
import { useRoute } from 'vue-router/composables';
import { useStore } from '@/store';
import type { BDropdown } from 'bootstrap-vue/src/components/dropdown';
import type { StoreType } from '@extTypes/api/customily/user';


export default /*#__PURE__*/_defineComponent({
  __name: 'StoreSelector',
  props: {
    storeTypes: null
  },
  emits: ["store-selected"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'store-selected', value: string | null): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    storeTypes?: StoreType[];
};





const { state, commit } = useStore();

const route = useRoute();

const isEmbedded = computed(() => route.query.embedded === 'true');

const storesDropdown: Ref<BDropdown | null> = ref(null);

/**
 * this getter maybe is unnecesary, because store always will
 * have value whenever selector is visible
 */
const storeSelectorTitle = computed(() => state.store || 'All stores');

const stores = computed(() => {
    const userStores = state.user?.customilyUser.Stores || [];
    return props.storeTypes ? userStores.filter((s) => props.storeTypes!.includes(s.Type)) : userStores;
});

onBeforeMount(() => {
    const isAvailableStore = stores.value.some((s) => s.Url == state.store);
    if (!isAvailableStore && stores.value.length) {
        commit('setStore', stores.value[0].Url);
    }
});

const onStoresDropdownClick = () => {
    storesDropdown.value?.show();
};

const setStoreUrl = (store: string | null) => {
    commit('setStore', store);
    emit('store-selected', store);
};

return { __sfc: true,emit, props, state, commit, route, isEmbedded, storesDropdown, storeSelectorTitle, stores, onStoresDropdownClick, setStoreUrl }
}

})